import * as React from 'react';

import * as styles from './SearchFiltersBlock.css';

interface ISearchFiltersBlockProps {
  searchBlock: React.ReactNode;
  quickFilters: React.ReactNode;
}

export const SearchFiltersBlock: React.FC<ISearchFiltersBlockProps> = ({ searchBlock, quickFilters }) => {
  return (
    <div className={styles['search-filters-block']}>
      {searchBlock}
      {quickFilters}
    </div>
  );
};
